import { render, staticRenderFns } from "./pageRightFloat.vue?vue&type=template&id=70e7ea39&scoped=true&"
import script from "./pageRightFloat.vue?vue&type=script&lang=js&"
export * from "./pageRightFloat.vue?vue&type=script&lang=js&"
import style0 from "./pageRightFloat.vue?vue&type=style&index=0&id=70e7ea39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7ea39",
  null
  
)

export default component.exports